<template>
  <section class="section">
    <div class="container">
      <!-- <LinkovaniLogotipovi /> -->
      <h1 class="title">Плаћање</h1>

      <div class="box">
        <h3 class="is-size-4">
          Јавно предузеће Дирекција за изградњу општине Параћин
        </h3>
        <h3 class="is-size-6">
          Владике Николаја Велимировића 1, 35250 Параћин
        </h3>
        <br />
        <h3 class="is-size-5">Број поруџбине: {{ narudzbinaId }}</h3>
        <h3 class="is-size-5">
          Износ и валута: {{ ukupnoZaUplatu }} {{ valuta }}
        </h3>
      </div>
      <div class="field">
        <b-checkbox
          v-model="saglasan"
          :disabled="saglasan"
          @input="onSaglasanChenged"
        >
          Сагласан са условима плаћања
        </b-checkbox>
        <b-button
          class="is-pulled-right"
          :disabled="saglasan"
          tag="router-link"
          :to="{
            path: '/kupovina',
            query: { step: '2' }
          }"
          >Назад</b-button
        >
      </div>

      <p v-show="saglasan && !checkoutId">Припрема за плаћање у току ...</p>
      <br />
      <form
        action="/placanje-sacuvaj"
        class="paymentWidgets"
        data-brands="VISA MASTER MAESTRO"
      ></form>
    </div>
    <!-- <footer class="footer">
      <div class="content has-text-centered">
        <img
          src="@/assets/images/visa-mastercard-maestro-horizontal-certified.svg"
          alt="Дирекција за изградњу општине Параћин"
          class="imageCss"
        />
      </div>
    </footer> -->
    <Footer />
  </section>
</template>

<script>
// import LinkovaniLogotipovi from '@/components/LinkovaniLogotipovi.vue'
import Footer from '@/components/Footer.vue'
import PlacanjeService from '../services/PlacanjeService'
import { mapState, mapGetters } from 'vuex'
// import { paymentBaseUrl } from '@/conf'

export default {
  components: {
    // LinkovaniLogotipovi,
    Footer
  },
  data() {
    return {
      valuta: 'RSD',
      checkoutId: null,
      // narudzbinaId: null,
      saglasan: false
    }
  },
  created() {
    // this.prepareCheckout()
    // this.sacuvajKorpu()
    // if (!this.narudzbinaId) {
    //   this.sacuvajKorpu()
    // }
  },
  methods: {
    onSaglasanChenged() {
      if (this.saglasan) {
        //this.sacuvajKorpu()
        this.prepareCheckout()
      }
    },

    prepareCheckout() {
      //console.log('test')
      PlacanjeService.prepareCheckout(
        this.ukupnoZaUplatu,
        this.narudzbinaId
      ).then(response => {
        // buildNumber: "7dacfff9258eb8531953cdbf10fdb2b2ebe821cc@2020-09-29 08:03:45 +0000"
        // id: "2A51CD64DEAE318B92DAE90575851CBD.uat01-vm-tx04"
        // ndc: "2A51CD64DEAE318B92DAE90575851CBD.uat01-vm-tx04"
        // result: {code: "000.200.100", description: "successfully created checkout"}
        // timestamp: "2020-09-29 09:38:54+0000"

        console.log(response.data)
        this.checkoutId = response.data.id
        this.sacuvajCheckoutId()
        this.createPaymentForm()
      })
    },
    sacuvajCheckoutId() {
      //console.log('test')
      PlacanjeService.sacuvajCheckoutId(
        this.narudzbinaId,
        this.checkoutId
      ).then(response => {
        console.log(response.data)
      })
    },
    createPaymentForm() {
      let paymentWidgetsScript = document.createElement('script')
      paymentWidgetsScript.setAttribute(
        'src',
        this.paymentBaseUrl +
          '/v1/paymentWidgets.js?checkoutId=' +
          this.checkoutId
      )
      document.head.appendChild(paymentWidgetsScript)
    }
  },
  computed: {
    ...mapState('placanje', [
      'korpa',
      'uplatilac',
      'narudzbinaId',
      'paymentBaseUrl'
    ]),
    ...mapGetters('placanje', ['ukupnoZaUplatu'])
  }
}
</script>

<style></style>
